import Icon from "@bokio/designsystem/components/Icon/Icon";
import { mergeClassNames } from "@bokio/utils/classes";

import type { FC } from "react";

import * as styles from "./dropdownIcon.scss";

interface DropdownIconProps {
	active?: boolean;
}

const DropdownIcon: FC<DropdownIconProps> = ({ active }) => (
	<div className={mergeClassNames(styles.wrapper, active && styles.rotated)}>
		<Icon name="down-open-big" size="18" />
	</div>
);

export default DropdownIcon;
